export enum ServiceTypeEnum {
  OneTime = "one_time",
  Program = "program",
}

export const serviceTypesList = Object.values(ServiceTypeEnum);

export enum ServiceStatusEnum {
  Published = "published",
  Draft = "draft",
  Completed = "completed",
  Expired = "expired",
}

export enum ServiceCategory {
  SkillDevelopment = "skill_development",
  HealthAndRecovery = "health_and_recovery",
  CareerManagement = "career_management",
  ClubGrowth = "club_growth",
  MediaAndEventManagement = "media_and_event_management",
}
export const serviceCategoryList = Object.values(ServiceCategory);

export enum ServiceSubCategory {
  SkillDev = "SKILLDEV",
  FitnessEnhance = "FITNESSENHANCE",
  TacticalAnalysis = "TACTICALANALYSIS",
  VideoTraining = "VIDEOTRAINING",
  Goalkeeping = "GOALKEEPING",
  YouthDev = "YOUTHDEV",
  InjuryRecovery = "INJURYRECOVERY",
  MassageTherapy = "MESSAGETHERAPY",
  MentalHealth = "MENTALHEALTH",
  HydrationAndNutrition = "HYDRATIONANDNUTRITION",
  BiomechanicsAnalysis = "BIOMECHANICSANALYSIS",
  CareerMngmnt = "CAREERMANAGEMENT",
  AgentServices = "AGENTSERVICES",
  BrandDev = "BRANDDEV",
  FinancialPlanning = "FINANCIALPLANING",
  LegalAdvisory = "LEGALADVISORY",
  ClubGrowth = "CLUBGROWTH",
  Sponsorship = "SPONSORSHIP",
  ClubGrowthFanEngagement = "CLUBGROWTHFANENGAGEMENT",
  Sustainability = "SUSTAINABILITY",
  ContentCreation = "CONTETNTCREATION",
  EventCoverage = "EVENTCOVERAGE",
  MediaFanEngagement = "MEDIAFANENGAGEMENT",
  CrisisMngmnt = "CRISISMANAGEMENT",
}
export const serviceSubCategoryList = Object.values(ServiceSubCategory);

export enum ProgramLevelEnum {
  Beginner = "beginner",
  Intermediate = "intermediate",
  Advanced = "advanced",
}
export const programLevelList = [ProgramLevelEnum.Beginner, ProgramLevelEnum.Intermediate, ProgramLevelEnum.Advanced];

export enum CurrencyEnum {
  USD = "USD",
  EGP = "EGP",
}
export const currencyList = [CurrencyEnum.USD, CurrencyEnum.EGP];

export enum ServiceRequestUnitEnum {
  Call = "call",
  Session = "session",
}
export const serviceRequestUnitList = [ServiceRequestUnitEnum.Call, ServiceRequestUnitEnum.Session];

export enum ServiceRequestTypeEnum {
  Unit = "unit",
  Fixed = "fixed",
}

export enum ServicePricingEnum {
  Fixed = "fixed",
  Subscription = "subscription",
}

export enum EquipmentCategory {
  ball_control_and_agility = "ball_control_and_agility",
  strength_and_power = "strength_and_power",
  endurance_and_speed = "endurance_and_speed",
  rehabilitation_and_recovery = "rehabilitation_and_recovery",
  specialized_training = "specialized_training",
}

export enum BallControlAndAgilityEquipment {
  Cones = "Cones",
  AgilityLadder = "AgilityLadder",
  SlalomPoles = "SlalomPoles",
  FootworkRings = "FootworkRings",
}
export const ballControlAndAgilityEquipmentsList = Object.values(BallControlAndAgilityEquipment);

export enum StrengthAndPowerEquipment {
  ResistanceBands = "ResistanceBands",
  Sled = "Sled",
  PlyometricBox = "PlyometricBox",
  MedicineBall = "MedicineBall",
  WeightsDumbbells = "WeightsDumbbells",
  SpeedParachute = "SpeedParachute",
  WeightedVest = "WeightedVest",
}
export const strengthAndPowerEquipmentsList = Object.values(StrengthAndPowerEquipment);

export enum EnduranceAndSpeedEquipment {
  SpeedHurdles = "SpeedHurdles",
  GpsTracker = "GpsTracker",
  JumpRope = "JumpRope",
  HeartRateMonitor = "HeartRateMonitor",
  SpeedResistanceBand = "SpeedResistanceBand",
}
export const enduranceAndSpeedEquipmentsList = Object.values(EnduranceAndSpeedEquipment);

export enum RehabilitationAndRecoveryEquipment {
  FoamRoller = "FoamRoller",
  BalanceBoard = "BalanceBoard",
  YogaMat = "YogaMat",
  CompressionSleeves = "CompressionSleeves",
}
export const rehabilitationAndRecoveryEquipmentsList = Object.values(RehabilitationAndRecoveryEquipment);

export enum SpecializedTrainingEquipment {
  KickTrainer = "KickTrainer",
  ReboundNet = "ReboundNet",
  JugglingNet = "JugglingNet",
  TennisBalls = "TennisBalls",
  ShootingTargets = "ShootingTargets",
  GoalKeeperGloves = "GoalKeeperGloves",
}
export const specializedTrainingEquipmentsList = Object.values(SpecializedTrainingEquipment);

export enum TeamAndStrategyEquipment {
  TacticBoard = "TacticBoard",
  PlayerBibs = "PlayerBibs",
}
export const teamAndStrategyEquipmentsList = Object.values(TeamAndStrategyEquipment);

export type AllRoles = "coach" | "athlete" | "admin" | "analyst";

export type ServiceDeliveryType = ServiceDeliveryEnum;

export enum ServiceDeliveryEnum {
  Online = "online",
  Onsite = "onsite",
}

export const serviceDeliveryList = Object.values(ServiceDeliveryEnum);

export enum ServiceAvailabilityEnum {
  Online = "online",
  Offline = "offline",
}
export const serviceAvailabilityList = Object.values(ServiceAvailabilityEnum);

export enum ServiceRequestStatusEnum {
  Initiate = "initiated",
  Negotiated = "negotiated", // contract created
  Contracted = "contracted", // contract accepted
  Completed = "completed",
  Rejected = "rejected",
  Canceled = "canceled",
}

export enum ServiceRequestTypeEnum {
  received = "received",
  ordered = "ordered",
}

export enum ServiceContractStatusEnum {
  Approved = "approved",
  Contracted = "contracted",
  Pending = "pending",
  Denied = "denied",
  CanceledAfterPaid = "cancelled_after_paid",
}

export enum MilestoneStatusEnum {
  Paid = "paid",
  Pinning = "pinning",
  Coming = "coming",
}

export enum ServiceProgramStatusEnum {
  Approved = "approved",
  Pending = "pending",
  Denied = "denied",
}

export enum ProgramJoinRequestStatusEnum {
  Pending = "pending",
  Success = "success",
  Failed = "failed",
}
